function initCarousel(selector, prevElementId, nextElementId, indicatorElementId) {
	var indicatorElement = document.getElementById(indicatorElementId);
	var prevElement = document.getElementById(prevElementId);
	var nextElement = document.getElementById(nextElementId);

	var siema = new Siema({
		selector: selector,
		duration: 200,
		easing: 'ease-out',
		perPage: 1,
		startIndex: 0,
		draggable: true,
		multipleDrag: true,
		threshold: 20,
		loop: true,
		rtl: false,
		onInit: () => {},
		onChange: function () {
			if(indicatorElement) indicatorElement.textContent = this.currentSlide + 1;
		},
	});

	if(prevElement) {
		prevElement.addEventListener('click', function () {
			siema.prev();
		});
	}
	if(nextElement) {
		nextElement.addEventListener('click', function () {
			siema.next();
		});
	}

	return siema;
}

// function initCarousel(selector, indicatorElementId) {
// 	var indicatorElement = document.getElementById(indicatorElementId);
//
// 	var splide = new Splide( '.splide', {
// 		type     : 'loop',
// 		height   : window.innerWidth > 1024 ? '35rem' : '16rem',
// 		focus    : 'left',
// 		pagination: false,
// 		gap: '4px',
// 		autoWidth: true,
// 	} );
// 	splide.mount();
// 	splide.on( 'move', () => {
// 		indicatorElement.textContent = splide.index + 1;
// 	} );
// }